import { TicketStatus, TicketPriority } from "../api/supportApi";

const STATUS_MAP: Record<
  TicketStatus,
  { label: string; cls: string }
> = {
  open:        { label: "Open",        cls: "bg-blue-50 text-blue-700 border-blue-100" },
  in_progress: { label: "In Progress", cls: "bg-amber-50 text-amber-700 border-amber-100" },
  resolved:    { label: "Resolved",    cls: "bg-emerald-50 text-emerald-700 border-emerald-100" },
  closed:      { label: "Closed",      cls: "bg-gray-50 text-gray-500 border-gray-200" },
};

const PRIORITY_MAP: Record<
  TicketPriority,
  { label: string; cls: string }
> = {
  low:    { label: "Low",    cls: "bg-gray-50 text-gray-500 border-gray-200" },
  medium: { label: "Medium", cls: "bg-blue-50 text-blue-600 border-blue-100" },
  high:   { label: "High",   cls: "bg-orange-50 text-orange-600 border-orange-100" },
  urgent: { label: "Urgent", cls: "bg-red-50 text-red-600 border-red-100" },
};

export function StatusBadge({ status }: { status: TicketStatus }) {
  const m = STATUS_MAP[status] ?? { label: status, cls: "bg-gray-50 text-gray-500 border-gray-200" };
  return (
    <span className={`px-2.5 py-0.5 rounded-lg border text-[10px] font-black uppercase tracking-wider ${m.cls}`}>
      {m.label}
    </span>
  );
}

export function PriorityBadge({ priority }: { priority: TicketPriority }) {
  const m = PRIORITY_MAP[priority] ?? { label: priority, cls: "bg-gray-50 text-gray-500 border-gray-200" };
  return (
    <span className={`px-2.5 py-0.5 rounded-lg border text-[10px] font-black uppercase tracking-wider ${m.cls}`}>
      {m.label}
    </span>
  );
}

export function statusOptions(): { value: TicketStatus; label: string }[] {
  return (Object.keys(STATUS_MAP) as TicketStatus[]).map((k) => ({
    value: k,
    label: STATUS_MAP[k].label,
  }));
}

export function priorityOptions(): { value: TicketPriority; label: string }[] {
  return (Object.keys(PRIORITY_MAP) as TicketPriority[]).map((k) => ({
    value: k,
    label: PRIORITY_MAP[k].label,
  }));
}
